/**
 * Created by marvin.ruppellt on 19.05.18.
 */
import React from 'react';
import Layout from '../layout/Layout';
import CmsContent from '../components/CmsContent';
var Datenschutz = function () { return (React.createElement(Layout, null,
    React.createElement(CmsContent, { page: "96" }))); };
export default Datenschutz;
